import { render, staticRenderFns } from "./dashboard_goals.vue?vue&type=template&id=52059790&scoped=true&"
import script from "./dashboard_goals.vue?vue&type=script&lang=js&"
export * from "./dashboard_goals.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_goals.vue?vue&type=style&index=0&id=52059790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52059790",
  null
  
)

export default component.exports